import { render } from "./ContactItem.vue?vue&type=template&id=7b55fc09"
import script from "./ContactItem.vue?vue&type=script&lang=js"
export * from "./ContactItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__